<template>
	<div class="docs-box">
		<div class="docs-home">
			<img src="./../../../assets/img/docs/001/01.jpg" />
			<div class="docs-home-btns">
				<span @click="$router.push('/docAnswer?answer=01')">如何成为代理人</span>
				<span @click="$router.push('/docAnswer?answer=02')">如何获得佣金</span>
				<span @click="$router.push('/docAnswer?answer=03')">如何发展下级</span>
				<span @click="$router.push('/docAnswer?answer=04')">佣金提现指引</span>
				<span @click="$router.push('/docAnswer?answer=05')">服务保障承诺</span>
			</div>
			<!-- <img src="./../../../assets/img/docs/001/04.jpeg" /> -->
		</div>		
	</div>
</template>
<script>
	export default{
		name:'docs-question'
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/docs/question.vue